import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '../auth/authContext';
import { useIsMobile } from '../hooks/useIsMobile';
export const Header = () => {
    const { user, logout } = useAuth();
    const isMobile = useIsMobile();
    return (_jsx("header", { style: styles.header, children: _jsxs("div", { style: {
                ...styles.container,
                padding: isMobile ? '12px 16px' : '16px 24px',
            }, children: [_jsx("div", { style: styles.logoSection, children: _jsx("h1", { style: {
                            ...styles.logo,
                            fontSize: isMobile ? '22px' : '24px',
                        }, children: "Glazier" }) }), _jsx("div", { style: styles.userSection, children: user && (_jsxs(_Fragment, { children: [!isMobile && (_jsx("span", { style: styles.userEmail, children: user.email })), _jsx("button", { onClick: logout, style: isMobile ? styles.logoutBtnMobile : styles.logoutBtn, children: "Sign Out" })] })) })] }) }));
};
const styles = {
    header: {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        color: '#1d1d1f',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logoSection: {
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        margin: 0,
        fontWeight: '700',
        background: 'linear-gradient(135deg, #0071e3 0%, #54b0fd 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    userSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    userEmail: {
        fontSize: '14px',
        color: '#86868b',
        fontWeight: '500',
    },
    logoutBtn: {
        padding: '8px 16px',
        backgroundColor: 'rgba(255, 59, 48, 0.1)',
        color: '#ff3b30',
        border: '1px solid rgba(255, 59, 48, 0.2)',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
    },
    logoutBtnMobile: {
        padding: '6px 10px',
        backgroundColor: 'rgba(255, 59, 48, 0.1)',
        color: '#ff3b30',
        border: '1px solid rgba(255, 59, 48, 0.2)',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
    },
};
//# sourceMappingURL=Header.js.map